module.exports = __webpack_public_path__ + "media/images/flags/mk-143fff99ad89cba0414b62850ab3fc5b.svg";